import { render, staticRenderFns } from "./LoadingListPlaceholder.vue?vue&type=template&id=488c4e80&scoped=true"
import script from "./LoadingListPlaceholder.vue?vue&type=script&lang=js"
export * from "./LoadingListPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./LoadingListPlaceholder.vue?vue&type=style&index=0&id=488c4e80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488c4e80",
  null
  
)

export default component.exports